import styled from 'styled-components';

interface Props {
  background?: string;
}

const PageContainer = styled.section<Props>`
  background: ${({ background }) => background || '#ffffff'};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
`;

export default PageContainer;
